import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { InputMoney } from '@nerdwallet/currency';
import num from '@nerdwallet/nw-client-lib/num';

import { MORTGAGE } from '../../../../lib/analytics-constants';
import { MortgageInput, inputOnChange } from '../../../../lib/utils';
import { debouncedTrackInputEvent } from '../../../../lib/analytics/trackers';
import useAnalytics from '../../../../lib/analytics/use-analytics';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

export type DownPaymentProps = MortgageInput & {
  purchasePrice: string | number;
};

const DownPaymentInput = ({
  value,
  dispatch,
  analytics,
  errorMessage,
  purchasePrice,
  label = '',
  tooltip = '',
  className = '',
  fullWidth,
}: DownPaymentProps): JSX.Element => {
  const segmentAbstract = useAnalytics();
  const error = Boolean(errorMessage);
  const analyticsEnabled = analytics && analytics?.enabled;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: OnChangeEvent) => {
    let bedrock;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_i',
      };
    }

    // segment analytics
    debouncedTrackInputEvent(
      {
        entityName: 'down_payment',
        field: 'Down Payment',
        field_type: 'user_type_input',
        field_value: e.target.value,
      },
      segmentAbstract
    );

    inputOnChange({
      event: e,
      dispatch,
      bedrock,
      fieldName: 'downPayment',
      calculator: MORTGAGE,
      inputType: 'currency',
      additionalInputIdsToValidate: ['purchasePrice'],
    });
  };

  const downPaymentLabel = (formatType) => {
    const downPayment = Number(value) / Number(purchasePrice);
    if (formatType === 'percent') {
      if (!_.isFinite(downPayment)) return '-';
      return num.formatPercent(downPayment, '0%');
    }
    return num.formatCurrency(downPayment);
  };

  const flooredValue = _.isNumber(value) ? Math.floor(Number(value)) : null;
  return (
    <InputMoney
      label={`${label} (${downPaymentLabel('percent')})`}
      value={flooredValue}
      placeholder={downPaymentLabel('')}
      error={error}
      errorMessage={errorMessage}
      onChange={onInputChange}
      tooltip={tooltip}
      className={className}
      fullWidth={fullWidth}
      // @ts-ignore - ignore error
      decimalScale={0}
    />
  );
};

const mapStateToProps = (state) => ({
  value: state?.mortgageCalculator?.inputs?.downPayment,
  purchasePrice: state?.mortgageCalculator?.inputs?.purchasePrice,
  errorMessage: state?.validations?.downPayment?.[0],
});

export default connect(mapStateToProps)(DownPaymentInput);
